import api from './api'

export default {
  loadOrganizations: async function ({ commit, dispatch, getters }) {
    if(getters.isLoadedDictionary('organizations')) {
      return
    }

    const data = await dispatch(`organizations/getOrganizations`, null, {root:true})
    commit('setOrganizations', data.raw)
  },
  loadBusinessGroups: async function ({ commit, dispatch, getters }) {
    if(getters.isLoadedDictionary('businessGroups')) {
      return
    }
    const data = await dispatch(`businessGroups/getBusinessGroups`, null, {root:true})
    commit('setBusinessGroups', data)
  },

  loadBillingInfos: async function ({ commit, dispatch, getters }) {
    if(getters.isLoadedDictionary('billingInfos')) {
      return
    }
    const data = await api.getBillingInfos();
    commit('setBillingInfos', data)
  },
  loadPricingLevelGroups: async function ({ commit, dispatch, getters }) {
    if(getters.isLoadedDictionary('pricingLevelGroups')) {
      return
    }
    const data = await api.getPriceLevelGroups();
    commit('setPricingLevelGroups', data)
  },
};
